/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'outline/12/arrow-down': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" _fill="none" stroke-linecap="round" stroke-linejoin="round" d="M.5 3.5l5.5 6 5.5-6" _stroke="#272c33"/>'
  }
})
